/* unplugin-vue-components disabled */import { render } from "./KilaKilaBackToTop.vue?vue&type=template&id=68d6ccb4&scoped=true"
import script from "./KilaKilaBackToTop.vue?vue&type=script&lang=js"
export * from "./KilaKilaBackToTop.vue?vue&type=script&lang=js"

import "./KilaKilaBackToTop.vue?vue&type=style&index=0&id=68d6ccb4&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d6ccb4"]])

export default __exports__